export const BOOZE_LIMITS: number[] = [
  1, 1, 1, 1, 2, 2, 3, 5, 8, 10, 12, 15, 18, 20, 25, 30, 35, 40, 41, 42, 43, 44,
  45, 46, 47, 48, 49, 50, 55, 60,
];

export const NARCS_LIMITS: number[] = [
  1, 1, 1, 1, 1, 1, 1, 2, 3, 5, 6, 7, 9, 10, 12, 15, 17, 20, 21, 22, 23, 24, 25,
  26, 27, 28, 29, 30, 35, 40,
];
